<div align ="center">
<h1>Error!</h1>
<p>Sorry! The page you were looking for doesn't exist.</p>
<a
  href="#"
  tc-button
  [afterIcon]="'icofont-ui-home'"
  [view]="'accent'"
  (click)="backtoHome()"
  
>Go back to home</a>


</div>
